// Map service names to obfuscated, user-friendly labels
const SERVICE_LABELS: Record<string, string> = {
  'ecommerce-api': 'Commerce Services',
  'customer-api': 'Customer Services',
  'backoffice-api': 'Admin Services',
  'onb-api': 'Onboarding Services',
  'prospects-api': 'Prospect Management',
  'tnube-api': 'Sales Channel Integration',
  ecommerce: 'Commerce Services',
  customer: 'Customer Services',
  backoffice: 'Admin Services',
  onb: 'Onboarding Services',
  prospects: 'Prospect Management',
  tnube: 'Sales Channel Integration',
};

export function getServiceLabel(serviceName: string): string {
  return SERVICE_LABELS[serviceName] || 'External Service';
}

export function getAvailableServiceLabels() {
  return { ...SERVICE_LABELS };
}
